import type { ReadonlyDeep } from 'type-fest';

import {
  AddressInput,
  CadastralInfoInput,
  LocationInfoInput,
  LocationTypeEnum,
  PostalInfoInput,
} from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import { isFormEmpty } from '../../utils/is-form-empty.util';

import type { AddressForm_Address } from '../fragments/address.fragment';

export function addressForm2ApiMapper(
  address: ReadonlyDeep<AddressForm_Address>,
): ReadonlyDeep<AddressInput> {
  const addressInput = pruneInput(address, AddressInput);

  const postalInfo =
    addressInput.postalInfo && !isFormEmpty({ node: addressInput.postalInfo })
      ? pruneInput(addressInput.postalInfo, PostalInfoInput)
      : undefined;

  const locationInfo =
    addressInput.locationInfo &&
    !isFormEmpty({
      node: addressInput.locationInfo,
      ignore: ['_id', '__typename', 'projectionId'],
    })
      ? pruneInput(addressInput.locationInfo, LocationInfoInput)
      : undefined;

  const cadastralInfo =
    addressInput.cadastralInfo &&
    !isFormEmpty({ node: addressInput.cadastralInfo })
      ? pruneInput(addressInput.cadastralInfo, CadastralInfoInput)
      : undefined;

  return {
    ...addressInput,
    locationInfo: locationInfo
      ? {
          ...locationInfo,
          type: LocationTypeEnum.Point,
        }
      : undefined,
    postalInfo,
    cadastralInfo,
  };
}
